<template>
    <div>
        <sub-menu-call-center ativo="lista" v-if="!cc" />

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Especialidades..."
                            icon="fas fa-filter" 
                            type="select" 
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            :optionsReload="true"
                            v-model="especialidade" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            type="select"
                            placeholder="Todos..."
                            :optionsList="[
                                { id: 'A', search: 'Esperando'}, 
                                { id: 'M', search: 'Marcados'},
                                { id: 'R', search: 'Removido'}
                            ]"
                            optionsData="id"
                            v-model="status_busca" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input
                            type="select"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            placeholder="Todas as Unidades..."
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-8">
                        <az-input icon="fas fa-search fa-fw" v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        {{ lista.length }}
                                    </div>
                                    <print-export printid="lista-marcacoes" :dados="dadosFormatados" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>    


        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum paciente encontrado.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="lista && lista.length" id="lista-marcacoes">

            <cabecalho-generico titulo="Lista de Espera">
            </cabecalho-generico>
                    
            <div class="card mb-2 w3-animate-opacity carde" v-for="(dado, iq) in lista" :key="iq">
                <div class="card-body p-1 px-2" :class="dado.ch_status == 'R' ? 'alert-secondary' : ''">
                    <div class="row">
                        <!-- Ação -->
                        <div class="col col-12 col-md-2 d-flex flex-column justify-content-center d-print-none">
                            <div class="my-1 text-center text-md-left">
                                <template v-if="dado && dado.ch_status == 'A'">
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-success mr-1 mb-1"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Agendar"
                                        @click="marcar (dado)"
                                    >
                                        <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-danger mr-1 mb-1"
                                        data-toggle="tooltip" data-placement="top" title="Remover da Lista de Espera"
                                        @click="remover(dado)">
                                        <i class="fas fa-minus-circle"></i>
                                    </button>
                                </template>
                                
                                <button type="button" class="btn btn-sm btn-secondary mr-1 mb-1" disabled v-else-if="dado && dado.ch_status == 'R'">
                                    Removido
                                </button>

                                <button type="button" class="btn btn-sm btn-secondary mr-1 mb-1" disabled v-else-if="dado && dado.ch_status == 'M'">
                                    Marcado
                                </button>

                                <button type="button" class="btn btn-sm btn-outline-primary mr-1 mb-1"
                                    data-toggle="tooltip" data-placement="top" title="Contatos"
                                    @click="abrir_contatos(dado)">
                                    <i class="fas fa-comments"></i>
                                    <span class="badge badge-primary ml-2" v-if="dado.contatos.length">
                                        {{ dado.contatos.length }}
                                    </span>
                                </button>

                                <a class="btn btn-outline-success btn-sm mr-1 mb-1" data-toggle2="tooltip" data-placement="top" title="Confirmação pelo WhatsApp"
                                    :href="whatsapp_link (dado)" :target="whatsapp_link (dado).substr(0,1) == 'j' ? '' : '_blank'">
                                    <i class="fab fa-whatsapp"></i>
                                </a>

                                <az-audit-log-button model="listaEspera" classes="mb-1" sizing="sm" :id="dado.id_lista_espera" />
                            </div>

                            

                        </div>

                        <!-- Identificação do Paciente -->
                        <div class="col col-12 col-md-3" v-if="dado">
                            <celula-dados-paciente 
                                :hor="{ marcacao: dado }" 
                                :anexos="true"
                                @abriranexos="abrir_anexar_arquivo" />
                        </div>

                        <!-- Contatos do Paciente -->
                        <div class="col col-12 col-md-2" v-if="dado">
                            <celula-dados-contatos :hor="{ marcacao: dado }" />
                        </div>

                        <!-- Identificação do Procedimento -->
                        <div class="col col-12 col-md-3" v-if="dado">
                            <celula-dados-procedimento 
                                :hor="{ marcacao: dado }" 
                                @abriranexos="abrir_anexar_arquivo" 
                                blockanexos2 />
                        </div>

                        <!-- Observação -->
                        <div class="col col-12 col-md-2 d-flex justify-content-between">
                            <div>
                                <span>{{ $util.getFormatDate(dado.created_at) }} {{ dado.created_at.substr(11,5) }}</span>
                                <div>
                                    <small>{{ dado.st_observacoes }}</small>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <template>
                                            <button class="dropdown-item" @click="cadastrar_paciente(dado)" :disabled="dado.id_paciente">Cadastrar Paciente</button>
                                            <button class="dropdown-item" @click="editar_observacao(dado)">Editar Observação</button>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="listaEsperaContatoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item && item.contato">
                    <div class="modal-header">
                        <h5 class="modal-title">Contatos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <celula-dados-paciente :hor="{ marcacao: item }" />

                                <az-input
                                    class="mt-3"
                                    label="Informações do Contato"
                                    type="textarea"
                                    rows="5"
                                    required
                                    :validate="validate"
                                    v-model="item.contato.st_observacoes" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <p class="alert alert-info" v-if="!item.contatos.length">
                                    Nenhum Contato Registrado.
                                </p>
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(contato, icx) in item.contatos" :key="icx">
                                        <div class="small text-muted">
                                            {{ contato.usuario.st_login }}, em 
                                            {{ $util.getFormatDate(contato.created_at) }}
                                            {{ contato.created_at.substr(11,5) }}
                                        </div>
                                        <div>{{ contato.st_observacoes }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="registrar_contato()">Registrar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="base_arquivo.arquivos"
                :parms="{ 
                    model_type: base_arquivo.id_lista_espera ? 'listaEspera' : ( base_arquivo.id_cadastro_temporario ? 'cadastroTemporario' : 'pessoa' ), 
                    model_id: base_arquivo.id_lista_espera ? base_arquivo.id_lista_espera : ( base_arquivo.id_cadastro_temporario ? base_arquivo.id_cadastro_temporario : base_arquivo.id_pessoa ), 
                    id_paciente: base_arquivo.id_paciente ? base_arquivo.id_paciente : base_arquivo.id_pessoa,
                    tipo_especial: base_arquivo.id_lista_espera ? null : 'anexo', 
                }" />
        </template>

        <cadastrar-novo-paciente ref="cadnovo" @refresh="load()" />

        <!-- Editar Obs Modal -->
        <div class="modal fade" id="editarObsEsperaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="edicao_obs">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar Observação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="{ marcacao: edicao_obs }" />
                            </div>
                            <div class="card-footer">
                                <div v-if="edicao_obs.procedimento">{{  edicao_obs.procedimento.search }}</div>
                                <div class="small" v-if="edicao_obs.medico">{{  edicao_obs.medico.search }}</div>
                            </div>
                        </div>

                        <az-input
                            class="mt-3"
                            label="Observação"
                            type="textarea"
                            rows="5"
                            :validate="validate"
                            v-model="edicao_obs.st_observacoes" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_obs()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import SubMenuCallCenter from './SubMenuCallCenter.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubmit from '../../util/AzSubmit.vue';

import CadastrarNovoPaciente from './CadastrarNovoPaciente.vue';

import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import CelulaDadosContatos from "../../shared/table/CelulaDadosContatos.vue";

import AzFileUpload from '../../util/AzFileUpload.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data () { 
        return { 
            dados: null, 
            item: null, 
            viewMode: 'A',
            search: "",
            validate: false, 
            status_busca: "A", 
            especialidade: "", 
            filtros_busca: null, 
            acao_anexar: null, 
            filtros: { 
                periodo: "",
                inicio: "",
                fim: "", 
                id_unidade_operacao: "", 
            },
            edicao_obs: null, 
        }
    },

    props: ['cc'], 

    watch: { 
        status_busca: function () { 
            this.load ();
        },

        especialidade: function() { 
            this.load();
        }
    },

    computed: { 
        dadosFormatados: function () { 
            return this.lista.map(item => { 
                return { 
                    id: item.id_lista_espera, 
                    paciente: item.nome_paciente, 
                    telefone: item.paciente 
                        ? item.paciente.cadastro.telefones.telefone
                        : item.cadastro_temporario.st_telefone, 
                    celular: item.paciente 
                        ? item.paciente.cadastro.telefones.celular
                        : item.cadastro_temporario.st_celular, 
                    email: item.paciente 
                        ? item.paciente.cadastro.st_email
                        : item.cadastro_temporario.st_email, 
                    procedimento: item.procedimento ? item.procedimento.search : '',
                    medico: item.medico ? item.medico.search : '', 
                    data: this.$util.getFormatDate(item.created_at) + ' ' + item.created_at.substr(11,5), 
                    obs: item.st_observacoes
                };
            });
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados ? 
                this.dados.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) : [];
        }
    },

    components: { 
        SubMenuCallCenter,
        AzInput, 
        AzAuditLogButton, 
        CelulaDadosPaciente,
        CelulaDadosProcedimento,
        CelulaDadosContatos,
        AzSubmit,
        PrintExport, 
        CabecalhoGenerico, 
        AzFileUpload, 
        AzPeriodo,
        CadastrarNovoPaciente
    },

    methods: { 
        atualizar_obs () { 
            this.$util.atualizar(this, { 
                service: 'lista_esperas',
                dados: { 
                    id_lista_espera: this.edicao_obs.id_lista_espera,
                    st_observacoes: this.edicao_obs.st_observacoes, 
                },
                reload: true, 
                toast: true,
                modal: 'editarObsEsperaModal',
            });
        },

        editar_observacao (item) {
            this.edicao_obs = _.cloneDeep(item);
            $('#editarObsEsperaModal').modal('show');
        },
        
        cadastrar_paciente (item) { 
            this.$refs.cadnovo.abrir(item);
        },

        registrar_contato() { 
            this.$util.atualizar(this, { 
                service: 'lista_espera_contatos',
                dados: this.item.contato,
                modal: 'listaEsperaContatoModal',
                reload: true, 
                toast: true,
                msg: 'Contato registrado.'
            });
        },

        abrir_contatos (item) { 
            this.validate = false;
            this.item = _.cloneDeep(item);
            this.item.contato = { 
                st_observacoes: "", 
                id_lista_espera: item.id_lista_espera, 
            };

            $('#listaEsperaContatoModal').modal('show');
        },

        remover (item) { 
            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( !confirm ('Confirma remover o paciente da lista de espera?') ) 
                return; 

            this.$util.atualizar (this, { 
                service: 'lista_esperas',
                dados: { 
                    id_lista_espera: item.id_lista_espera,
                    ch_status: 'R', 
                },
                reload: true, 
                toast: true, 
            });
            
        },

        marcar(item) {
            $('[data-toggle="tooltip"]').tooltip("dispose");
            this.$router.push({
                name: "call-center",
                params: { espera: item.id_lista_espera }
            });
        },

        load () { 
            this.acao_anexar = false;

            this.$util.load(this, { 
                service: 'lista_esperas', 
                parms: { 
                    especialidade: this.especialidade, 
                    ...this.filtros, 
                    cc: this.cc ? true : false, 
                    para_lista: true, 
                    where: ( this.status_busca ? { ch_status: this.status_busca } : {} ),
                }
            });
        },

        abrir_anexar_arquivo(item) {
            this.base_arquivo = item;
            this.acao_anexar = true;

            this.carregar_arquivos(true);
            
            /*
            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
            */
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            if ( this.base_arquivo.id_lista_espera ) { 

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.base_arquivo.id_lista_espera,
                        type: 'listaEspera',
                    }
                })
                .then(res => {
                    this.base_arquivo.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                            this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            } else if ( this.base_arquivo.id_cadastro_temporario ) { 

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.base_arquivo.id_cadastro_temporario,
                        type: 'cadastroTemporario',
                    }
                })
                .then(res => {
                    this.base_arquivo.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                            this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            } else { 

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.base_arquivo.id_pessoa,
                        type: 'pessoa',
                    }
                })
                .then(res => {
                    this.base_arquivo.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                            this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            }

        },

        whatsapp_link(marcacao) {

            let nl = "%0D%0A";
            let msg = "Olá, ";
            let celular = "";

            if (marcacao.paciente) {
                msg = msg + marcacao.paciente.st_nome;
                celular = marcacao.paciente.cadastro.telefones.celular;
            } else {
                msg = msg + marcacao.cadastro_temporario.st_nome;
                celular = marcacao.cadastro_temporario.st_celular;
            }

            if (!celular) {
                return "javascript:alert('Celular não disponível')";
            }

            celular = "55" + celular;

            msg = msg + nl;

            return "https://wa.me/" + celular + "?text=" + msg;
        },

    },

    beforeMount () {  
        this.filtros.inicio = moment().subtract(180, "days").format('YYYY-MM-DD');
        this.filtros.fim = moment().format('YYYY-MM-DD');
    },

    mounted () {
        this.$store.commit("setBreadcrumb", [
            { name: "Call Center", path: "/call-center" },
            { name: "Lista de Espera", path: "/call-center/listaespera" }
        ]);

        this.load ();
    },

    updated () { 
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    }
}
</script>